(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[405],{

/***/ 5301:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(441);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 441:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9008);
/* harmony import */ var _styles_Home_module_css__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6134);
/* harmony import */ var _styles_Home_module_css__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_styles_Home_module_css__WEBPACK_IMPORTED_MODULE_2__);


// import Image from 'next/image';

var Home = function() {
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(next_head__WEBPACK_IMPORTED_MODULE_1__["default"], {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                        children: "anthony.app"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "description",
                        content: "web software engineer in Minneapolis"
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("main", {
                className: (_styles_Home_module_css__WEBPACK_IMPORTED_MODULE_2___default().container),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                        className: (_styles_Home_module_css__WEBPACK_IMPORTED_MODULE_2___default().header),
                        children: "welcome 👋"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                        className: (_styles_Home_module_css__WEBPACK_IMPORTED_MODULE_2___default().text),
                        children: "Anthony’s a Minneapolis-based remote software engineer (he/they) who traffics in high-level languages (e.g., Node, JavaScript, TypeScript), serverless/full-stack framework-based web apps (e.g., λ functions, Next.js, React, Svelte), & design systems (e.g., a11y, Material Design, Bootstrap, tailwind.css)."
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                        className: (_styles_Home_module_css__WEBPACK_IMPORTED_MODULE_2___default().text),
                        children: "He maintains many hats as a docs-writer, library-builder, UX/DX-improver, CI/CD-automator, scripter, git-hooker, & open-source contributor."
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                        className: (_styles_Home_module_css__WEBPACK_IMPORTED_MODULE_2___default().text),
                        children: "All in pursuit of building human-centered software."
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("ul", {
                className: (_styles_Home_module_css__WEBPACK_IMPORTED_MODULE_2___default().list),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                            className: (_styles_Home_module_css__WEBPACK_IMPORTED_MODULE_2___default().link),
                            href: "/resume",
                            children: "r\xe9sum\xe9"
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                            className: (_styles_Home_module_css__WEBPACK_IMPORTED_MODULE_2___default().link),
                            href: "https://github.com/4cm4k1",
                            children: "github"
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                            className: (_styles_Home_module_css__WEBPACK_IMPORTED_MODULE_2___default().link),
                            rel: "me",
                            href: "https://mastodon.social/@4cm4k1",
                            children: "mastodon"
                        })
                    })
                ]
            })
        ]
    }));
};
/* harmony default export */ __webpack_exports__["default"] = (Home);


/***/ }),

/***/ 6134:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"text":"Home_text__ATnaE","link":"Home_link__Z_A7p","header":"Home_header__qwdnY","slant":"Home_slant__l2hKJ","container":"Home_container__Ennsq","list":"Home_list__9JfPL","footer":"Home_footer__7dKhS","logo":"Home_logo__80mSr"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [888,774,179], function() { return __webpack_exec__(5301); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);